module.exports = __webpack_public_path__ + "static/media/s97ga04.190b63be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/s97ga04.gif
// module id = 269
// module chunks = 0